<template>
  <v-card>
    <div class="d-flex flex-sm-row flex-column">
      <div class="flex-grow-1">
        <v-card-title>
          <span class="me-3 error--text">รายการถอน</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 pb-8">
          <v-data-table
            mobile-breakpoint="0"
            :headers="headers"
            :items="transection"
            :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.status`]="{ item }">
              <div
                :class="`${
                  item.status === 'denied'
                    ? 'error'
                    : item.status === 'wait'
                    ? 'warning'
                    : item.status === 'cancel'
                    ? 'error'
                    : 'success'
                } popout`"
              ></div>
              <span>{{
                item.status === 'denied'
                  ? 'ไม่อนุมัติ'
                  : item.status === 'wait'
                  ? 'รออนุมัติ'
                  : item.status === 'cancel'
                  ? 'ไม่อนุมัติ'
                  : 'อนุมัติ'
              }}</span>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              <span>{{ formatDate(item.created_at) }}</span>
            </template>
            <!--เพิ่ม บัญชีนอก symbol-->
            <template v-slot:[`item.bank`]="{ item }">
                <div class="ma-auto mt-2" style="width: 24px;height: 24px;aspect-ratio: 1;display: grid;">
                    <!-- Additional Withdraw: KR bank (CDN logo) -->
                    <div v-if="item.isAdditionalWithdraw && item.additionalBankCountry">
                        <img v-if="item.additionalBank" alt="bank_img"
                            style="object-fit: contain;height: inherit;width: 100%;"
                            :src="`https://www.ak47.services/akasset-v2/banks/${item.additionalBankCountry}/${item.additionalBank}.webp`" />
                    </div>
                    <!-- Additional Withdraw: TH bank (local logo) -->
                    <div v-else-if="item.isAdditionalWithdraw && item.additionalBank">
                        <img alt="bank_img"
                            style="object-fit: contain;height: inherit;width: 100%;"
                            :src="require(`@/assets/images/logos/banks/${item.additionalBank}.png`)" />
                    </div>
                    <!-- Normal: KR/KH/LA bank (CDN logo) -->
                    <div v-else-if="item.bankCountry">
                        <img v-if="item.bank" alt="bank_img"
                            style="object-fit: contain;height: inherit;width: 100%;"
                            :src="`https://www.ak47.services/akasset-v2/banks/${item.bankCountry}/${item.bank}.webp`" />
                    </div>
                    <!-- Normal: TH bank (local logo) -->
                    <div v-else>
                        <img v-if="item.bank && item.bank !== 'RBS'" alt="bank_img"
                            style="object-fit: contain;height: inherit;width: 100%;"
                            :src="require(`@/assets/images/logos/banks/${item.bank}.png`)" />
                    </div>
                </div>
                <!-- เลขบัญชี -->
                <span>{{ item.isAdditionalWithdraw ? item.additionalWithdrawBankNumber : item.bank_account }}</span>
                <!-- Badge สีแดง: บัญชีนอก -->
                <div v-if="item.isAdditionalWithdraw" class="mt-1 mb-1">
                    <v-chip x-small class="white--text" style="height: 22px; background-color: #F44336 !important;">บัญชีนอก</v-chip>
                </div>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <span>{{ item.amount | currency }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    transection: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'ชื่อ',
          value: 'bank_name',
          width: '100px',
          sortable: false,
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          sortable: false,
        },
        {
          text: 'ธนาคาร',
          value: 'bank',
          align: 'center',
          sortable: false,
        },
        // {
        //   text: 'เลขที่บัญชี',
        //   value: 'bank_account',
        //   sortable: false,
        // },
        {
          text: 'สั่งถอนเมื่อ',
          value: 'created_at',
          width: '95px',
          sortable: false,
        },
        {
          text: 'จำนวนเงิน',
          value: 'amount',
          align: 'end',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YY-MM-DD HH:mm')
    },
  },
}
</script>
<style scoped>
.popout {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: popout 2s infinite;
  -webkit-animation: popout 1s infinite;
  aspect-ratio: 1/1;
}
.flex-grow-1 {
  width: 100% !important;
}

@keyframes popout {
  from {
    transform: scale(0);
  }
  80% {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}
@-webkit-keyframes popout {
  from {
    -webkit-transform: scale(0);
  }
  80% {
    -webkit-transform: scale(1.2);
  }
  to {
    -webkit-transform: scale(1);
  }
}
</style>
